export const FEATURE_FLAGS = {
  BRANDING_FEATURE: 'branding-feature',
  EXPORT_FEATURE: 'export-feature',
  PROJECT_LANGUAGE_FEATURE: 'project-language-feature',
  PROJECT_CONTEXT_FEATURE: 'project-context-feature',
  HYPERBEAM_FEATURE: 'hyperbeam-feature',
  AI_MODERATED_TEST_FEATURE: 'ai-moderated-test-feature',
  REPORT_PROBLEM_FEATURE: 'report-problem-feature',
  ORG_INTRO_VIDEOS: 'org-intro-videos',
  PUBLISH_DROPDOWN: 'publish-dropdown',
  PROBLEM_REPORTING_MANAGER_PANEL: 'problem-reporting-manager-panel-feature',
} as const;
